<template>
  <header class="c-header c-header--dark c-header--exam">
    <div class="c-title bg-black d-flex align-items-center d-lg-none">
      <div class="container">
        <h1 class="w-medium fs-18 white mb-0">
          Examen de: <span class="w-bold">{{ course.title }}</span>
        </h1>
      </div>
    </div>
    <div class="container">
      <nav class="c-nav d-flex align-items-center justify-content-between">
        <div class="c-nav__left">
          <h1 class="w-medium d-none d-lg-block fs-21 white mb-1">
            Examen de: <span class="w-bold">{{ course.title }}</span>
          </h1>
          <router-link
            v-if="previousRoute"
            :to="previousRoute"
            class="c-link c-link--white white d-flex align-items-center">
            <i class="iconf-left-arrow d-flex align-items-center me-2"></i>
            Volver al curso
          </router-link>
        </div>
        <div class="c-nav__right">
          <Profile v-if="user" :body="user"></Profile>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

import Profile from '../Profile.vue';

export default {
  data() {
    return {
      user: null,
      previousRoute: '',
    };
  },
  components: {
    Profile,
  },
  props: ['course', 'goBack'],
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
  },
  watch: {
    userData(data) {
      this.user = data;
    },
  },
  mounted() {
    this.user = this.userData;
    if (localStorage.getItem('previousRoute')) {
      this.previousRoute = localStorage.getItem('previousRoute');
    }
  },
};
</script>
